import styled from "styled-components";

export const BlockStyle = styled.section`
    margin-top: .42rem;
    h2{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: .34rem;
        font-weight: 600;
        color: #434669;
        margin-bottom: .31rem;
        padding-right: .2rem;
        a{
            font-size: .22rem;
            font-weight: 400;
            color: rgba(12,16,57,0.50);
        }
    }
`;
